import { colors } from "@biblioteksentralen/utils";
import { defineRecipe } from "@chakra-ui/react";

export const SpinnerStyles = defineRecipe({
  base: {
    animationDuration: ".8s",
    color: colors.accentBlueMedium,
    // Todo: Legg til trackColor: https://chakra-ui.com/docs/components/spinner#track-color
    borderWidth: ".175em",
  },
});
